import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import router from './router'

Vue.config.productionTip = false

// Variaveis globais
// Vue.prototype.$ambiente = 'DEV' // # ### Retirar comentário na Produção ***
// Vue.prototype.$urlDEV = 'http://sposvmcmehml02:8090'
Vue.prototype.$urlDEV = 'http://127.0.0.1:5000'
Vue.prototype.$tempoErrosNaTela = 2 * 60 * 60000 //EM MILESIMOS DE SEGUNDO (60000 = 60 SEGUNDOS)


// Inicializar plugin de Máscara nos campos.
// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask'
Vue.use(VueMask);

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
